module.exports = __webpack_public_path__ + "313d228646aec912b9f6f60febc8918b.png";